<div hsg-modal-header *ngIf="data.title">
	<h3>{{ data.title }}</h3>
	<a class="modal-close-icon cancel" hsgModalClose>
		<span class="icon-cross"></span>
	</a>
</div>
<div hsg-modal-body [ngClass]="{ 'loading': loading }">
    <table *ngIf="importedRows && importedRows.length > 0">
        <thead>
            <tr>
                <th>Facility Name</th>
                <th>Cost Center ID</th>
                <th>Cost Center Name</th>
                <th>Patient HIS ID</th>
                <th>Patient First Name</th>
                <th>Patient Last Name</th>
                <th>Service Date Time</th>
                <th>UOS Information</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let importedRow of importedRows">
                <td>{{ importedRow.facilityName }}</td>
                <td>{{ importedRow.hisCostCenterId }}</td>
                <td>{{ importedRow.costCenterName }}</td>
                <td>{{ importedRow.patientHisId }}</td>
                <td>{{ importedRow.patientFirstName }}</td>
                <td>{{ importedRow.patientLastName }}</td>
                <td>{{ importedRow.serviceDateTime | date:'short' }}</td>
                <td>{{ importedRow.uosInformation }}</td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="!loading && (!importedRows || importedRows.length == 0)">There is no imported data to display for this shift block.</div>
</div>
<div hsg-modal-footer>
	<button class="cancel" [hsgModalClose]="false" *ngIf="data.rejectText">
		{{ data.rejectText }}
	</button>
</div>